import { lazy, Suspense } from "react";
import { BrowserRouter as Router, Route } from "react-router-dom";
import SuspenseLoader from "./components/SuspenseLoader";

const Home = lazy(() => import("../src/pages/Home"));
const Visitor = lazy(() => import("../src/pages/VisitorInfo"));
const Service = lazy(() => import("../src/pages/Service"));
const About = lazy(() => import("../src/pages/About"));
const Portfolio = lazy(() => import("../src/pages/Portfolio"));
const Contact = lazy(() => import("../src/pages/Contact"));


function App() {
  return (
    <Suspense fallback={<SuspenseLoader />}>
      <Router>
        <Route exact path="/" render={() => <Home />} />
        <Route path="/service" render={() => <Service />} />
        <Route path="/about" render={() => <About />} />
        <Route path="/work" render={() => <Portfolio />} />
        <Route path="/contact" render={() => <Contact />} />
      </Router>
    </Suspense>
  );
}

export default App;
